import React from "react";
import CyclesMapView from "../components/liqmap/CyclesMapView";

// Thin page wrapper for /liquidity-map/cycles.
export default function CyclesMapPage() {
  return <CyclesMapView />;
}
